<template>
  <div id="app">

    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'App',
    data(){
      return {
        global:{
          lang:'EN'
        }
      }
    },
    mounted() {
      window.addEventListener('resize', (e) => {
        if (window.document.documentElement.clientWidth <=1024) {
          this.setFontSize()
          console.log(1)
        }else {
          window.document.documentElement.style.fontSize='12px';
        }
      })
    },
    created() {
      if (window.document.documentElement.clientWidth <= 1024) this.setFontSize()
    },
    methods: {
      setFontSize() {
        const documentElement = window.document.documentElement
        let width = documentElement.clientWidth// > 750 ? 750 : documentElement.clientWidth;
        documentElement.style.fontSize = width / 7.5 + 'px'
      }
    }
  }
</script>

<style lang="scss">
  /*#app {*/
    /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
    /*-webkit-font-smoothing: antialiased;*/
    /*-moz-osx-font-smoothing: grayscale;*/
    /*text-align: center;*/
    /*color: #2c3e50;*/
    /*margin-top: 60px;*/
  /*}*/
  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed,
  figure, figcaption, footer, header, hgroup,
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }
  /* HTML5 display-role reset for older browsers */
  article, aside, details, figcaption, figure,
  footer, header, hgroup, menu, nav, section {
    display: block;
  }
  body {
    line-height: 1;
  }
  ol, ul {
    list-style: none;
  }
  blockquote, q {
    quotes: none;
  }
  blockquote:before, blockquote:after,
  q:before, q:after {
    content: '';
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
  img{
    display: block;
  }

  .con{
    width: 1200px;
    margin:0 auto;
  }
  #app .nav .nav_content .item{
    cursor: pointer;
  }


</style>



// WEBPACK FOOTER //
// src/App.vue